<template>
    <div class="m-content">
        {{ message.content.text }}
    </div>
</template>

<style scoped>
    .m-content {
        white-space: -moz-pre-wrap; /* Mozilla, supported since 1999 */
        white-space: -pre-wrap; /* Opera */
        white-space: -o-pre-wrap; /* Opera */
        white-space: pre-wrap; /* CSS3 - Text module (Candidate Recommendation) http://www.w3.org/TR/css3-text/#white-space */
        word-wrap: break-word; /* IE 5.5+ */
        word-break: break-all;
    }
</style>

<script>
    export default {
        props: {
            message: Object,
            instanceId: String
        }
    }
</script>
